import { render, staticRenderFns } from "./MemberDetail.vue?vue&type=template&id=c679fe30&scoped=true&"
import script from "./MemberDetail.vue?vue&type=script&lang=js&"
export * from "./MemberDetail.vue?vue&type=script&lang=js&"
import style0 from "./MemberDetail.vue?vue&type=style&index=0&id=c679fe30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c679fe30",
  null
  
)

export default component.exports